import Toast from "@/components/Toast";
import { TOAST_TYPE } from "@/components/Toast";
import { createApp } from "vue";

let $vm;
const toast = {};

toast.install = function (app) {
  if (!$vm) {
    const toast = createApp(Toast);
    $vm = toast.mount(document.createElement("div"));
    document.body.appendChild($vm.$el);
  }

  $vm.isShow = false;

  let toast = {
    show(props) {
      const { msg, type = TOAST_TYPE.SUCCESS, time = 3000 } = props;
      $vm.isShow = true;
      $vm.msg = msg;
      $vm.type = type;
      $vm.time = time;

      setTimeout(() => {
        this.hide();
      }, time);
    },
    hide() {
      $vm.isShow = false;
    },
  };

  if (!app.$toast) {
    app.$toast = toast;
  }

  app.config.globalProperties.$toast = app.$toast;
};

export default toast;
